export enum ArchivesActionTypes {
  DESELECT_ALL_DOCUMENTS = 'DESELECT_ALL_DOCUMENTS',
  GET_SEARCH_ARCHIVES = 'GET_SEARCH_ARCHIVES',
  GET_ARCHIVE_CONFIG = 'GET_ARCHIVE_CONFIG',
  GET_ARCHIVE_RIGHTS = 'GET_ARCHIVE_RIGHTS',
  SEND_ARCHIVES = 'SEND_ARCHIVES',
  SHARE_ARCHIVES = 'SHARE_ARCHIVES',
  UPLOAD_ARCHIVE = 'UPLOAD_ARCHIVE',
  POST_ARCHIVE = 'POST_ARCHIVE',
  SELECT_DOCUMENTS = 'SELECT_DOCUMENTS',
  GET_ARCHIVES_DOWNLOAD = 'GET_ARCHIVES_DOWNLOAD'
}
